module.exports = __webpack_public_path__ + "static/media/FreeStylePart2.594c71fd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/FreeStyle/FreeStylePart2.mp3
// module id = 132
// module chunks = 0